<template>
  <div>
    <!-- {{JSON.stringify(dataSource)}} -->
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="masterDetailColumns"
      :data-source="dataSource"
      @editor-preparing="onEditorPreparing"
      @content-ready="onContentReady"
      @init-new-row="onInitNewRow"
      @row-removed="onRowRemoved"
      :columnChooser="{
        enabled: false,
      }"
      :pager="{
        visible: false,
      }"
    >
      <DxSearchPanel :visible="false" />
      <DxEditing :allow-deleting="true" :allow-updating="true" mode="cell" />
      <template #itemSelect="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data.BatchNo }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierCode }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierName }}</span>
          <span class="auto-complete-secondary">{{ data.UseByDate }}</span>
          <span class="auto-complete-secondary">{{ data.AvailableQty }}</span>
        </div>
      </template>
      <template #supplier-cell-template="{ data }">
        <GcDescriptionCodeCellTemplate
          :description="data.data.SupplierName"
          :code="data.data.SupplierCode"
        />
      </template>

      <template #expiry-date-template="{ data }">
        <DxDateBox :value="data.data.ExpiryDate" type="date" />
      </template>

      <template #available-quantity-template="{ data }">
        <DxNumberBox :value="data.data.AvailableQty" />
      </template>

      <template #quantity-template="{ data }">
        <DxNumberBox :value="data.data.Qty" />
      </template>

      <template #qtyEditTemplate="{ data }">
        <div>
          <div>
            <DxNumberBox
              :value="data.value"
              @value-changed="batchQtyChanged($event, data)"
              :format="getDecimalFormatByCode(2).Format"
              class="gc-grid-number-box-editor"
              :min="-99999999"
              :max="99999999"
            />
          </div>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
import { DxNumberBox } from "devextreme-vue/number-box";
import BaseViewMixin from "../../src/v1/_mixins/base.view";

import { ProductBatchService } from "../_services/api/inventory/product-batch.service";

let baseLineBase = {
  BatchNo: "",
  SupplierName: "",
  SupplierCode: "",
  UseByDate: "",
  AvailableQty: null,
  Qty: 0,
};

let addingNewBatchRow = false;

export default {
  components: { DxDataGrid, DxDateBox, DxNumberBox },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validationErrors: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.PickingSlipProductBatches,
      batchDS: ProductBatchService.dataSourceConfig("api/ConsumeProductBatch", {
        filter: [
          ["ItemCode", "=", this.templateData.data.ItemCode],
          ["BranchCode", "=", this.parentModel.BranchCode],
          ["SourceTransactionType", "=", ""],
          ["SourceTransactionNo", "=", 0],
          ["SourceTransactionLine", "=", 0],
          ["SourceTransactionProcessCode", "=", ""],
        ],
        postProcess: (data) => {
          let foundInAllocatedBatches = [];
          if (data.length > 0) {
            data.forEach((record, i) => {
              let found = this.templateData.data.BatchesDetails.find(
                (x) =>
                  x.BranchCode == record.BranchCode &&
                  x.CompanyCode == record.CompanyCode &&
                  x.ItemCode == record.ItemCode &&
                  x.SupplierCode == record.SupplierCode &&
                  x.BatchNo == record.BatchNo
              );

              if (found) {
                data[i] = found;
                foundInAllocatedBatches.push(found);
              }
            });
          }

          this.templateData.data.BatchesDetails.forEach((element) => {
            let found = foundInAllocatedBatches.find(
              (x) =>
                x.BranchCode == element.BranchCode &&
                x.CompanyCode == element.CompanyCode &&
                x.ItemCode == element.ItemCode &&
                x.SupplierCode == element.SupplierCode &&
                x.BatchNo == element.BatchNo
            );

            if (!found) {
              data.push(element);
            }
          });

          return data;
        },
      }),
      localItems: [],
    };
  },
  created() {
    if (this.dataSource.length == 0) this.onAddClickHandler();
    this.batchDS.load().then((res) => {
      this.localItems = [...res];
    });
  },
  methods: {
    onEditorPreparing(e) {
      var rowIndex = e.row && e.row.rowIndex;

      if (e.dataField === "BatchNo") {
        e.editorOptions.onValueChanged = (e) => {
          if (e.value == null) {
            this.dataSource.splice(rowIndex, 1);
            this.recalculateTotal();
          }
        };

        e.editorOptions.onItemClick = (e) => {
          if (e.itemData) {
            var rec = e.itemData;
            this.dataSource[rowIndex].BatchNo = rec.BatchNo;
            this.dataSource[rowIndex].SupplierCode = rec.SupplierCode;
            this.dataSource[rowIndex].SupplierName = rec.SupplierName;
            this.dataSource[rowIndex].UseByDate = rec.UseByDate;
            this.dataSource[rowIndex].AvailableQty = rec.AvailableQty;
            this.dataSource[rowIndex].Qty = rec.Qty;
            this.dataSource[rowIndex].ItemCode = rec.ItemCode;
            this.dataSource[rowIndex].BranchCode = rec.BranchCode;
            this.dataSource[rowIndex].ProductDescrition1 =
              rec.ProductDescrition1;
            this.recalculateTotal();
          }
        };
      }
    },
    batchQtyChanged(e, cellInfo) {
      if (this.dataSource.length > 0) {
        if (this.dataSource[cellInfo.rowIndex].AvailableQty < e.value) {
          if (this.dataSource[cellInfo.rowIndex].ProductDescrition1)
            this.validationErrors([
              `${
                this.dataSource[cellInfo.rowIndex].ProductDescrition1
              } only has ${
                this.dataSource[cellInfo.rowIndex].AvailableQty
              } left to pick.  Please enter in a picked quantity that is ${
                this.dataSource[cellInfo.rowIndex].AvailableQty
              } or less.`,
            ]);
          e.component.beginUpdate();
          e.component.option("value", e.previousValue);
          e.component.endUpdate();
          this.dataSource[cellInfo.rowIndex].Qty = e.previousValue;
          this.recalculateTotal();
        } else {
          this.dataSource[cellInfo.rowIndex].Qty = e.value;
          this.recalculateTotal();
        }
      }
    },
    onInitNewRow(e) {
      e.data.Qty = 0;
    },
    onRowRemoved() {
      this.recalculateTotal();
    },
    // eslint-disable-next-line no-unused-vars
    onContentReady(e) {
      // this.$logger.debug("content ready", e);
      e.component.beginUpdate();
      e.component.updateDimensions();
      e.component.endUpdate();

      if (addingNewBatchRow) {
        addingNewBatchRow = false;
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        let recordCount = grid.getDataSource().items().length;
        // this.$logger.debug(recordCount);
        if (recordCount > 0) {
          let editElement = grid.getCellElement(recordCount - 1, 0);
          grid.focus(editElement);
          editElement.click();
        }
      }
    },

    onAddClickHandler() {
      let obj = Object.assign({}, baseLineBase);
      this.dataSource.push(obj);
      if (this.$refs["batch-child-grid-" + this.templateData.key]) {
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        grid.repaint();
      }
      addingNewBatchRow = true;
    },
    recalculateTotal() {
      let totalBatchPickedQty = 0;
      this.dataSource.forEach((x) => {
        totalBatchPickedQty += x.Qty;
      });

      // this.$logger.debug("totalBatchPickedQty", totalBatchPickedQty);

      this.templateData.data.SalesUMPickedQty = totalBatchPickedQty;

      this.templateData.data.Completed =
        this.templateData.data.SalesUMPickedQty >=
        this.templateData.data.SalesUMBackorderQty;
    },
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
    masterDetailColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Batch",
          dataField: "BatchNo",
          gcType: "String",
          gcSubType: "PrimaryChildRecord",
          editorType: "dxSelectBox",
          width: 200,
          editorOptions: {
            deferRendering: false,
            items: this.localItems,
            displayExpr: "BatchNo",
            valueExpr: "BatchNo",
            searchExpr: ["BatchNo"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "itemSelect",
            searchEnabled: true,
            dropDownOptions: {
              minWidth: 500,
            },
            onOpened: (e) => {
              e.component.beginUpdate();

              var items = e.component.getDataSource().items();
              items.forEach((item) => {
                item.disabled = false;
                e.component.option("items", items);
              });

              let grid = this.$refs["batch-child-grid-" + this.templateData.key]
                .instance;
              let records = grid.getDataSource().items();

              records.forEach((element) => {
                items.forEach((item, index) => {
                  if (element.BatchNo == item.BatchNo) {
                    items[index].disabled = true;
                    e.component.option("items", items);
                  }
                });
              });
              e.component.endUpdate();
            },
          },
          showEditorAlways: true,
          allowEditing: true,
          cssClass: "gc-editor-cell",
        },
        {
          gcLabel: "Supplier",
          dataField: "SupplierName",
          cellTemplate: "supplier-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
        },
        {
          gcLabel: "SupplierCode",
          dataField: "SupplierCode",
          gcType: "String",
          allowEditing: false,
          width: 450,
          visible: false,
        },
        {
          gcLabel: "Use By Date",
          dataField: "UseByDate",
          gcType: "Date",
        },
        {
          gcLabel: "Available",
          dataField: "AvailableQty",
          gcType: "Decimal-6-2",
        },
        {
          gcLabel: "Quantity",
          dataField: "Qty",
          gcType: "Decimal-6-2",
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: true,
          cssClass: "gc-editor-cell",
        },

        {
          gcLabel: "",
          gcType: "String",
          type: "buttons",
          width: 110,
          buttons: [
            "delete",
            {
              hint: "Add Batch Line",
              icon: "plus",
              visible: true,
              onClick: this.onAddClickHandler.bind(this),
            },
          ],
        },
      ]);
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
/* @import "../dx-styles.scss"; */
</style>
